import Action from './Action'
export class RequestAction {
    ID: number;
    RequestID: number;
    ActionID: number;
    Action: Action;
    Notes: string;
    
}

export default RequestAction;